import React from 'react';
import { Container } from "@material-ui/core";
import useStyles from "./styles";

const EmbeddedLayout = ({ children }) => {
  const classes = useStyles();
  return (<div className={`${classes.formWrapper} rootFormWrapper`}>{ children }</div>)
}

export default EmbeddedLayout
